import Vue from 'vue';
import VueI18n from 'vue-i18n';
import I18nMessages from '@/i18n-messages';

Vue.use(VueI18n);

export default new VueI18n({
  locale: process.env.VUE_APP_LANGUAGE,
  messages: I18nMessages,
});
